import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { deleteTypes } from '../constant'
import classes from './index.module.scss'
import {
  changeDeleteType,
  checkItem,
  selectChecked,
  selectDeleteType,
  selectPage,
  selectPageSize,
  uncheckAllItem,
} from './store/slice'

const Count = ({
  deleteTemplate,
  typeTemplate,
  total,
  defaultTemplate,
  idKey,
}) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectChecked)
  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)
  const deleteType = useSelector(selectDeleteType)

  const [isShowPopupDelete, setIsShowPopupDelete] = useState(false)

  const idsChecked = Object.keys(checked)

  const length = idsChecked.length

  const deleteAllChecked = () => {
    deleteTemplate({
      param: { ids: idsChecked, templateType: typeTemplate, deleteType },
      paramGet: {
        Page: page,
        PageSize: pageSize,
        TemplateType: typeTemplate,
      },
    })
    dispatch(changeDeleteType(deleteTypes.IN))
    dispatch(uncheckAllItem())
    closePopupDelete()
  }

  const selectAll = () => {
    if (lengthItemSelect > 0) {
      dispatch(changeDeleteType(deleteTypes.NOTIN))
      dispatch(uncheckAllItem())
      if (defaultTemplate[idKey]) {
        dispatch(checkItem(defaultTemplate[idKey]))
      }
    }
  }

  const unSelectAll = () => {
    dispatch(changeDeleteType(deleteTypes.IN))
    dispatch(uncheckAllItem())
  }

  const openPopupDelete = () => setIsShowPopupDelete(true)

  const closePopupDelete = () => setIsShowPopupDelete(false)

  const isDeleteIn = deleteType === deleteTypes.IN
  const countDefaultTemplate = defaultTemplate?.isDefault ? 1 : 0
  const countFiinGateTemplate = defaultTemplate?.isFiinGateTemplate ? 0 : 1
  const lengthItemSelect = total - countDefaultTemplate - countFiinGateTemplate
  const countSelected = isDeleteIn
    ? length
    : total - length - countFiinGateTemplate

  return (
    <div className={`dFlex alignItemsCenter ${classes.h32px}`}>
      <span className="fw600">
        <Translate value="preferenceSetting.SELECTED_1" />
        {countSelected}{' '}
        <Translate
          value={`preferenceSetting.${countSelected > 1 ? 'ITEMS' : 'ITEM'}`}
        />{' '}
        <Translate value="preferenceSetting.SELECTED_2" />
        &nbsp;
      </span>
      {(isDeleteIn && length === lengthItemSelect) ||
      (!isDeleteIn && length <= countDefaultTemplate) ? (
        <Element
          elementName="span"
          style={{ color: '#2C73E8' }}
          className="fw600 cursorPointer"
          onClick={unSelectAll}
        >
          <Translate value="preferenceSetting.UNSELECT" />
        </Element>
      ) : (
        <Element
          elementName="span"
          style={{ color: '#2C73E8' }}
          className="fw600 cursorPointer"
          onClick={selectAll}
        >
          <Translate value="preferenceSetting.SELECT_ALL" />
          {Math.max(lengthItemSelect, 0)}
          <Translate
            value={`preferenceSetting.${
              lengthItemSelect > 1 ? 'ITEMS_2' : 'ITEM_2'
            }`}
          />
        </Element>
      )}
      {!!length && (
        <Element
          style={{ background: '#F2F7FF', color: '#2C73E8' }}
          className={classes.deleteAll}
          onClick={openPopupDelete}
        >
          <Icon className="icon-trash-fill" />
        </Element>
      )}
      <PopupAction
        isShow={isShowPopupDelete}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={closePopupDelete}
        btnCancel={{
          label: 'common.NO',
          event: closePopupDelete,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: deleteAllChecked,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.DELETE_CONFIRM_3" />
      </PopupAction>
    </div>
  )
}

export default Count
